/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { showToast } from 'src/core/helpers'
import { Button, Divider, Form } from 'antd'
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import { CampaignPayload } from 'src/core/models'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTextInput, CustomText, CustomModal } from 'src/components'
import {
  createCampaingStateSelector,
  resetCreateCampaignsState,
  userAuthenticatedState,
  campaingsStateSelector,
  createCampaing,
} from 'src/features'

interface CampaignFormProps {
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
}

const CampaignForm: React.FC<CampaignFormProps> = (props) => {
  const { isModalVisible, setIsModalVisible } = props
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const [isErrorVisible, setIsErrorVisible] = useState<boolean>(false)
  const { email } = useAppSelector(userAuthenticatedState)
  const { data: campaingsList } = useAppSelector(campaingsStateSelector)
  const {
    loading: loadingCreate,
    success: successCreate,
    hasExistsError
  } = useAppSelector(createCampaingStateSelector)

  const handleSubmit = (values: CampaignPayload) => {
    dispatch(resetCreateCampaignsState())
    dispatch(createCampaing(values, campaingsList, email))
  }

  const handleCancel = () => {
    form.resetFields()
    setIsModalVisible(false)
    setIsErrorVisible(false)
  }

  useEffect(() => {
    if (successCreate) {
      handleCancel()
      showToast('success', t('Vouchers.CampaignCreated'), 3)
      dispatch(resetCreateCampaignsState())
    }
    if (hasExistsError) {
      setIsErrorVisible(true)
      dispatch(resetCreateCampaignsState())
    }
  }, [successCreate, hasExistsError])

  return (
    <CustomModal
      title={t('Vouchers.CreateCampaign')}
      footer={null}
      open={isModalVisible}
      onCancel={handleCancel}
    >
      <Form form={form} onFinish={handleSubmit}>

        {/* Code */}
        <CustomText label={t('card.Code')} />
        <CustomTextInput
          name='code'
          placeholder={t('Vouchers.CodePlaceholder')}
          minLengthAllowed={5}
          noSpacedAllowed
          required
        />

        {/* Name */}
        <CustomText label={t('footPrint.Name')} />
        <CustomTextInput
          name='name'
          placeholder={t('settings.NamePlaceHolder')}
          required
        />

        {isErrorVisible && (
          <div className={'blink-animation'}>
            <CustomText
              label={t('Vouchers.OnwerError')}
              type='danger'
            />
          </div>
        )}

        <Divider />
        <Button
          type='primary'
          htmlType='submit'
          loading={loadingCreate}
          icon={<SendOutlined />}
          block
        >
          {loadingCreate ? t('Vouchers.AddingCampaing') : t('Vouchers.AddCampaing')}
        </Button>
      </Form>
    </CustomModal>
  )
}

export default CampaignForm
